import React from "react";
import { connect } from "react-redux";
import { notification } from "../../services";
import { Notification } from "../../lib";
import { Merge } from "../../models";
import { Content, Container } from "../../pages/Template";
import { Compare } from "../../components/Merge";
import Header from "./Header";
import Actions from "./Actions";
import RequestHeader from "./RequestHeader";
import { setWindowTitle } from "../../helpers";
import { AxiosResponse } from "axios";
import { MergeRequest } from "../MergeRequestsPage";
import { AppState } from "../../store";

type OwnProps = {
    doc_id: number;
    match: {
        params: {
            doc_id: string;
            request_id: string;
            src: string;
            dst: string;
        };
    };
};
const mapStateToProps = (
    { user }: AppState,
    {
        match: {
            params: { doc_id },
        },
    }: OwnProps
) => ({
    user,
    doc_id: parseInt(doc_id),
});
type StateProps = ReturnType<typeof mapStateToProps>;

type Props = StateProps & OwnProps;
type State = {
    request: MergeRequest | null;
    loaded: boolean;
    decided: boolean;
    compare: {
        src: number;
        dst: number;
    };
};

class MergeResolvePage extends React.Component<Props, State> {
    static paths = ["/app/merge/resolve/:doc_id/:request_id/:src/:dst/"];
    static requiresAuth = true;

    constructor(props: Props) {
        super(props);

        this.state = {
            request: null,
            loaded: false,
            decided: false,
            compare: {
                src: -1,
                dst: -1,
            },
        };

        this.onAccept = this.onAccept.bind(this);
        this.onReject = this.onReject.bind(this);
    }

    componentDidMount() {
        this.fetch();
        setWindowTitle("کام ملاؤ");
    }

    async fetch() {
        this.setState({ loaded: false });

        try {
            const { doc_id } = this.props;
            const { request_id } = this.props.match.params;
            const { data }: AxiosResponse<MergeRequest> = await Merge.fetch(
                `request/${request_id}`,
                {
                    doc_id,
                }
            );

            if (["OPEN", "PENDING"].includes(data.status)) {
                this.setState({ request: data });
            } else if (data.status === "REJECTED") {
                this.setState({ decided: true });
                notification.set("merge.alreadyRejected", "f");
            } else if (data.status === "RESOLVED") {
                this.setState({ decided: true });
                notification.set("merge.alreadyResolved", "i");
            }
        } catch (e) {}
    }

    async onAccept() {
        try {
            const { doc_id, request_id } = this.props.match.params;
            await Merge.save("", `request/${request_id}`, { doc_id });
            this.setState({ decided: true });
            notification.set("merge.accepted", "s");
        } catch (e) {}
    }

    async onReject() {
        try {
            const { doc_id, request_id } = this.props.match.params;
            await Merge.destroy(`request/${request_id}`, { doc_id });
            this.setState({ decided: true });
            notification.set("merge.rejected", "f");
        } catch (e) {}
    }

    render() {
        const { decided, request } = this.state;
        const { doc_id } = this.props;
        const { src, dst } = this.props.match.params;
        const compare = {
            src: parseInt(src),
            dst: parseInt(dst),
        };
        const operational = !decided && request;

        return (
            <Content>
                <Container width="80%">
                    <Header />
                    <Actions
                        decided={decided}
                        onAccept={this.onAccept}
                        onReject={this.onReject}
                    />
                    {operational && <RequestHeader request={request!} />}
                    <Notification margin="40px 0 0 0" />
                    {operational && (
                        <Compare doc_id={doc_id} compare={compare} />
                    )}
                </Container>
            </Content>
        );
    }
}

export default connect(mapStateToProps)(MergeResolvePage);
